/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Button } from 'antd';
import colors from 'constants/colors';

const OlympicListCard = ({ index, exercise, onClick }) => {
  return (
    <div className="exercise-card d-flex justify-content-center my-3">
      <div className="d-flex flex-grow-1 bg-white" style={{ maxWidth: 850, borderRadius: 5, border: `1px solid ${exercise.color[index]}` }}>
        <div style={{
          minWidth: 50,
          color: 'white',
          textAlign: 'center',
          background: exercise.color[index],
          position: 'relative',
        }}
        >
          <div style={{ fontSize: 28, fontWeight: 700, font: '700 "Trebuchet MS",sans-serif', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            {exercise.tagName}
          </div>
        </div>
        <div className="d-flex flex-grow-1 align-items-center">
          <div className="flex-grow-1 py-2 px-3">
            <div className="d-flex flex-grow-1">
              <div style={{ flex: 1, fontSize: 25, color: exercise.color[index] }}>{exercise.title}</div>
              <Button onClick={onClick} type="dashed" shape="circle" className="d-block d-md-none" style={{ background: exercise.color[index], color: 'white', marginRight: 15, height: 'fit-content', fontWeight: 600 }}>
                <i className='fa fa-pen-square' />
              </Button>
            </div>
            <div>
              <span style={{ color: colors.gray[600] }}>Loại bài làm: </span>
              {exercise.skills.map((item, i) => {
                const isLast = exercise.skills.length - 1 !== i;
                return (
                  <React.Fragment key={i}>
                    <span>{item.visible && item.name}</span>
                    {isLast && <span style={{ color: exercise.color[index] }}> | </span>}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <Button onClick={onClick} className="px-3 py-2 d-none d-md-block" style={{ background: exercise.color[index], color: 'white', marginRight: 15, height: 'fit-content', fontWeight: 500 }}>Bắt đầu luyện tập</Button>
        </div>
      </div>
    </div>
  );
};
export default OlympicListCard;
